export const ThemeKey: string = 'theme';
